import styled, { css } from 'styled-components';

import { getColorByName } from '~/helpers/getColors';
import { mq } from '~/styles/grid';
import { HoverDesktop } from '../CTASkins';
import { CTABasics } from './CTA.basic';
import { CTAtertiaryWithAniIconSkin } from './CTA.tertiary';

const CTAnavigationHeaderSkin = css`
  ${CTABasics};
  gap: 8px;
  color: ${({ theme }) =>
    getColorByName(theme, theme.header.fontColor)} !important;
  cursor: pointer !important;
  display: flex;
  font-size: ${({ theme }) => theme.header.fontSize};
  height: 100%;
  background: ${({ theme }) =>
    getColorByName(theme, theme.header.bgColor)} !important;
  align-items: center;

  svg {
    max-height: 16px !important;
  }

  .iconBefore {
    margin-right: 0;
    display: flex;
  }

  ${HoverDesktop};
  @media (${mq.mdUp}) {
    justify-content: space-between;
    .text::after {
      background: ${({ theme }) =>
        getColorByName(theme, theme.header.fontColor)} !important;
    }
  }
`;

const CTAnavigationFooterSkin = css`
  ${CTAnavigationHeaderSkin};
  color: ${({ theme }) =>
    getColorByName(theme, theme.footer.fontColor)} !important;
  background-color: transparent !important;
  padding: 12px 0px;

  :hover {
    opacity: 1 !important;
  }

  @media (${(props) => props.theme.teaserCareer.mobileSwitch}) {
    padding: 0;
    margin: 0;
    line-height: 25px;
  }

  @media (${mq.mdUp}) {
    .text::after {
      background: ${({ theme }) =>
        getColorByName(theme, theme.footer.fontColor)} !important;
    }
  }
`;

const CTAnavigationFooterWithAniIconSkin = css`
  ${CTAtertiaryWithAniIconSkin};
  color: ${({ theme }) =>
    getColorByName(theme, theme.footer.fontColor)} !important;
  font-family: ${(props) => props.theme.font.regular} !important;
  background-color: transparent !important;
  display: flex;
  align-items: center;
`;

export const CTAnavigationHeader = styled.div`
  ${CTAnavigationHeaderSkin};
`;

export const CTAnavigationItem = styled.div`
  ${CTAnavigationHeaderSkin};
  @media (${({ theme }) => theme.header.mobileSwitch}) {
    height: 24px;
    margin: 8px 0;
  }
`;

export const CTAnavigationFooter = styled.div`
  ${CTAnavigationFooterSkin};
`;

export const CTAnavigationWithAniIcon = styled.div`
  ${CTAnavigationFooterWithAniIconSkin}
`;
